import { SVGProps } from 'react';
import { ReactComponent } from 'icons/link-icon.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const LinkIcon = (props: Props) => {
  return <ReactComponent className="merc-icon-link" {...props} />;
};
